<forge-card>
    @if (isLoaded) {
    <div>
        <form #form="ngForm">
            <div fxLayout="column" fxLayoutAlign="space-between">
                <metadata-panel ngModelGroup="pnl_edit" [metadata]="metadata" [model]="entity" [viewOnly]="!saveable"
                    class="standardMetadata">
                </metadata-panel>
            </div>
        </form>
        @if (saveable) {
        <div class="actions" fxLayout="row" fxLayoutAlign="end center">
            <forge-button variant="outlined" (click)="onCancel()" telemetry="Submission-InfoCardCancel">
                Cancel
            </forge-button>
            <forge-button variant="raised" [disabled]="!formValid" (click)="onSave()"
                telemetry="Submission-InfoCardSave">
                Save
            </forge-button>
        </div>
        }
    </div>
    }

    @if (!isLoaded) {
    <busy-indicator [page]="true"></busy-indicator>
    }
</forge-card>